/** @file 问答 语言配置 */
const zhCN = {
  questionAnswer: {
    title: '问答',
    count1: '共',
    count2: '条问题',
    noData: '共0条问题',
    notPublic: '私聊',
    relatedToMe: '与我相关',
    allMsg: '全部',
    tipsLoading: '加载中……',
    tipsNoData: '暂无问答，快来提问吧～',
    askLabel: '问',
    answerLabel: '答',
    sendFailed: '提问消息发送失败',
    sendSuccess: '发送成功',
    socketFailed: '找不到socket对象',
    noQuestionContent: '提问内容不能为空',
    send: '发送',
    askPlaceholder: '我也来提问',
    aboutMe: '@我',
    newsAboutMe: '@我 有新回复',
    news: '有新问答消息',
    cancel: '取消',
    asked: '提问',
    answered: '回复',
    me: '(我)',
    addReply: '追加',
    tipsBottom: '已经到底啦~',
    ignore: '忽略',
    End: '答题已结束',
    success: '已答题',
    submitSuccess: '答题成功',
    pictureReply: '图片回复',
    expand: '展开',
    shrink: '收起',
  },
};

const en = {
  questionAnswer: {
    // 问答
    title: 'Q&A',
    count1: '',
    count2: 'questions',
    noData: 'No questions',
    notPublic: 'Private chat',
    relatedToMe: 'About me',
    allMsg: 'View all',
    tipsLoading: 'Loading...',
    tipsNoData: 'No questions at the moment，come and ask！',
    askLabel: 'Q',
    answerLabel: 'A',
    sendFailed: 'Failed to send message.',
    socketFailed: 'Socket object not found.',
    noQuestionContent: 'Question content cannot be empty.',
    send: 'Send',
    sendSuccess: 'Send Success',
    askPlaceholder: 'What\'s your question?',
    aboutMe: '@me',
    newsAboutMe: 'News about me',
    news: 'News',
    cancel: 'Cancel',
    asked: 'asked',
    answered: 'answered',
    me: '(me)',
    addReply: 'A',
    tipsBottom: 'No more updates~',
    ignore: 'Ignore',
    End: 'End',
    success: 'Success',
    submitSuccess: 'Success',
    pictureReply: 'Picture reply',
    expand: 'Expand',
    shrink: 'Up',
  },
};

export default {
  zh_CN: zhCN,
  en,
};
